<template>
  <div class="form-group">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div class="mb-0 font-weight-bold">
        Líneas Estratégicas:
        <span class="text-danger">*</span>
        <b-badge variant="secondary" class="ml-2">{{
          strategicLines.length
        }}</b-badge>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-primary"
        @click="$emit('add-item')"
      >
        <i class="fa fa-plus"></i> Añadir Línea
      </button>
    </div>
    <div v-if="strategicLines.length === 0" class="text-muted mb-3">
      <small
        >No hay líneas estratégicas. Haz clic en "Añadir Línea" para agregar
        una.</small
      >
    </div>
    <div
      v-for="(line, index) in strategicLines"
      :key="`line-${index}-${line.id || 'new'}`"
      class="mb-3 p-3 border rounded relation-item"
      :class="getBorderClass(line, index)"
    >
      <div class="d-flex justify-content-between align-items-start mb-2">
        <div class="mb-0 font-weight-bold">
          Línea {{ index + 1 }}:
          <b-badge
            v-if="line.id === null"
            variant="success"
            class="ml-1"
            >Nuevo</b-badge
          >
        </div>
        <button
          type="button"
          class="btn btn-sm btn-danger"
          @click="$emit('remove-item', index)"
        >
          <i class="fa fa-trash"></i>
        </button>
      </div>
      <textarea
        :value="line.description"
        @input="$emit('update-item', index, $event.target.value)"
        @blur="$emit('touch-field', index)"
        class="form-control"
        :class="{ 'is-invalid': hasError(index) }"
        :id="`strategic-line-${index}`"
        rows="3"
        placeholder="Ingrese la descripción de la línea estratégica (máx. 1000 caracteres)"
        maxlength="1000"
      ></textarea>
      <div v-if="hasError(index)" class="invalid-feedback">
        <div v-if="!isFieldValid(index, 'required')">{{ errorMessages.required }}</div>
        <div v-if="!isFieldValid(index, 'maxLength')">{{ errorMessages.maxLength(1000) }}</div>
      </div>
      <small class="text-muted"
        >{{ line.description ? line.description.length : 0 }}/1000
        caracteres</small
      >
    </div>
  </div>
</template>

<script>
import { errorMessages } from "@/helpers/validations/errorMessages";

export default {
  name: "StrategicLinesTab",
  props: {
    strategicLines: {
      type: Array,
      default: () => [],
    },
    fieldErrors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      errorMessages,
    };
  },
  methods: {
    hasError(index) {
      return this.fieldErrors[index] && this.fieldErrors[index].hasError;
    },
    isFieldValid(index, rule) {
      if (!this.fieldErrors[index]) return true;
      return this.fieldErrors[index][rule] !== false;
    },
    getBorderClass(line, index) {
      const hasError = this.hasError(index);
      const hasContent = line.description && line.description.trim() !== '';
      
      if (hasError) {
        return 'border-danger';
      } else if (line.id === null && hasContent) {
        return 'border-success';
      } else if (line.id !== null && !hasError) {
        return 'border-primary';
      } else {
        return 'border-secondary';
      }
    },
  },
  emits: ["add-item", "remove-item", "update-item", "touch-field"],
};
</script>
